import React from "react";

// "KS" Monogram + optional wordmark — Cormorant Garamond italic with emerald accent dot
export default function Logo({ variant = "full", className = "", invert = false }) {
  const ink = invert ? "#FAF6EE" : "#1E1B4B";
  const accent = "#D97706";

  return (
    <a
      href="/"
      data-testid="site-logo"
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label="Karamjeet Sodhi — home"
    >
      <span
        aria-hidden
        className="relative inline-block"
        style={{ color: ink, fontFamily: '"Cormorant Garamond", serif' }}
      >
        <span className="text-3xl font-medium italic leading-none tracking-tight">
          K<span style={{ marginLeft: "-0.18em" }}>S</span>
        </span>
        <span
          aria-hidden
          className="absolute -right-1 -bottom-0.5 inline-block h-1.5 w-1.5 rounded-full"
          style={{ background: accent }}
        />
      </span>
      {variant === "full" && (
        <span
          className="hidden sm:inline-block text-[10px] uppercase tracking-[0.32em] font-medium"
          style={{ color: ink, fontFamily: "Outfit, sans-serif" }}
        >
          Karamjeet&nbsp;Sodhi
        </span>
      )}
    </a>
  );
}
